<template>
  <div>
    <div class="pb-2 text-xs-left" :class="[$style.headingText]">
      {{ lang.spine_title }}
    </div>

    <v-layout justify-center>
      <v-flex sm12 md6 class="py-2">
        <vc-share-comic-spine-preview
          :spine-image-url="spineImageUrl"
          :spine-image-aspect-ratio="
            spineImageHeightRecommended / spineImageWidthRecommended
          "
          :layout-key="stepNumber.toString()"
        ></vc-share-comic-spine-preview>
      </v-flex>
    </v-layout>
    <div v-if="!isUploadIceContents">
      <v-layout justify-center>
        <ul :class="$style.noteList">
          <li>{{ spineImageSizeRecommended }}</li>
        </ul>
      </v-layout>
      <v-layout justify-center class="py-3">
        <v-btn
          :class="$style.btnTextStyle"
          @click="onClickEditButton"
          :disabled="isBusy"
        >
          {{ lang.spine_edit }}
        </v-btn>

        <v-dialog
          v-model="selectSpineImageDialog"
          @keydown.esc="!isBusy ? (selectSpineImageDialog = false) : null"
          max-width="960"
          :persistent="isBusy"
        >
          <v-card>
            <v-card-title> {{ lang.spine_edit_dialog_title }} </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="spineCoverType"
                :class="['d-block', $style.radioContainer]"
              >
                <v-layout
                  :row="!$vuetify.breakpoint.xs"
                  :column="$vuetify.breakpoint.xs"
                  justify-center
                >
                  <v-flex
                    :class="[
                      $style.radioContainer__container,
                      $vuetify.breakpoint.xs
                        ? $style.radioContainer__container__xs
                        : null
                    ]"
                  >
                    <div
                      :class="[
                        $style.radioContainer__borderBox,
                        $style.radioContainer__radioContainer,
                        $vuetify.breakpoint.xs
                          ? $style.radioContainer__radioContainer__xs
                          : null
                      ]"
                      @click="spineCoverType = 'simple'"
                    >
                      <div
                        :class="[
                          $style.radioContainer__radio,
                          $vuetify.breakpoint.xs
                            ? $style.radioContainer__radio__xs
                            : null
                        ]"
                      >
                        <v-radio value="simple"></v-radio>
                      </div>

                      <div class="mb-4">
                        <vc-share-comic-spine-preview
                          :spine-image-url="defaultSpineImageUrl"
                          :spine-image-aspect-ratio="
                            spineImageHeightRecommended /
                              spineImageWidthRecommended
                          "
                          :layout-key="selectSpineImageDialog.toString()"
                        ></vc-share-comic-spine-preview>
                      </div>

                      {{ lang.spine_edit_dialog_select_simple_spine }}
                    </div>
                  </v-flex>
                  <v-flex
                    :class="[
                      $style.radioContainer__container,
                      $vuetify.breakpoint.xs
                        ? $style.radioContainer__container__xs
                        : null
                    ]"
                  >
                    <div
                      :class="[
                        $style.radioContainer__borderBox,
                        $style.radioContainer__radioContainer,
                        $vuetify.breakpoint.xs
                          ? $style.radioContainer__radioContainer__xs
                          : null
                      ]"
                      @click="spineCoverType = 'user_upload'"
                    >
                      <div
                        :class="[
                          $style.radioContainer__radio,
                          $vuetify.breakpoint.xs
                            ? $style.radioContainer__radio__xs
                            : null
                        ]"
                      >
                        <v-radio value="user_upload"></v-radio>
                      </div>

                      <div class="mb-4">
                        <vc-share-comic-spine-preview
                          :spine-image-url="
                            spineImageDataUrl || userSpineImageUrl
                          "
                          :spine-image-aspect-ratio="
                            spineImageHeightRecommended /
                              spineImageWidthRecommended
                          "
                          :layout-key="selectSpineImageDialog.toString()"
                        ></vc-share-comic-spine-preview>
                      </div>

                      <v-layout justify-center>
                        <ul :class="$style.noteList">
                          <li>{{ spineImageSizeRecommended }}</li>
                        </ul>
                      </v-layout>

                      <v-btn
                        color="primary"
                        :class="$style.btnTextStyle"
                        @click="onClickSpineImageFile"
                        :disabled="spineCoverType !== 'user_upload'"
                      >
                        {{ lang.spine_edit_dialog_select_file }}
                      </v-btn>

                      <input
                        type="file"
                        style="display: none"
                        ref="spineImageFileInput"
                        accept="image/png,image/jpeg, image/jpg"
                        @change="onChangeSpineImageFileInput"
                      />
                      <v-alert
                        v-for="(message, key, index) in errorMessages"
                        :key="index"
                        :value="true"
                        type="error"
                      >
                        {{ message }}
                      </v-alert>
                    </div>
                  </v-flex>
                </v-layout>
              </v-radio-group>

              <v-layout justify-end>
                <v-btn
                  :class="$style.btnTextStyle"
                  color="primary"
                  @click="onClickSaveButton"
                  :loading="isBusy"
                  :disabled="
                    spineCoverType === 'user_upload' && spineImageFile === null
                  "
                >
                  {{ lang.spine_edit_dialog_apply }}
                </v-btn>

                <v-btn
                  :class="$style.btnTextStyle"
                  color="default"
                  @click="selectSpineImageDialog = false"
                  :disabled="isBusy"
                >
                  {{ lang.spine_edit_dialog_cancel }}
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </div>
</template>
<script>
const MAX_IMAGE_FILE_SIZE_HUMAN = 32;
const MAX_IMAGE_FILE_SIZE = 1024 * 1024 * MAX_IMAGE_FILE_SIZE_HUMAN;

export default {
  name: "vc-share-comic-spine",
  data() {
    return {
      selectSpineImageDialog: false,
      spineCoverType: this.initialSpineCoverType,
      spineImageFile: null,
      spineImageDataUrl: null,
      errorMessages: []
    };
  },
  props: {
    lang: {
      type: Object,
      default: () => ({
        spine_title: "背表紙画像",
        spine_note_image_size: "適切な画像サイズ：:width * :height px",
        spine_edit: "変更",
        spine_edit_dialog_title: "裏表紙画像設定",
        spine_edit_dialog_select_simple_spine: "シンプルな背表紙",
        spine_edit_dialog_select_file: "ファイルを選択",
        spine_edit_dialog_apply: "適用",
        spine_edit_dialog_cancel: "キャンセル"
      })
    },

    /* stateToProps */
    isBusy: {
      type: Boolean,
      default: false
    },
    defaultSpineImageUrl: {
      type: String,
      default: ""
    },
    initialSpineCoverType: {
      type: String,
      default: ""
    },
    userSpineImageUrl: {
      type: String,
      default: ""
    },
    stepNumber: {
      type: Number,
      default: 1
    },
    isUploadIceContents: {
      type: Boolean,
      default: false
    },

    /* gettersToProps */
    spineImageWidthRecommended: {
      type: Number,
      default: 0
    },
    spineImageHeightRecommended: {
      type: Number,
      default: 0
    },
    spineImageUrl: {
      type: String,
      default: ""
    },

    /* actionsToProps */
    postUserSpineImage: {
      type: Function,
      default: () => {}
    },

    /* mutationsToProps */
    setIsBusy: {
      type: Function,
      default: () => {}
    },
    updateSpineCoverType: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    selectSpineImageDialog() {
      if (this.selectSpineImageDialog) {
        this.initialData();
      }
    }
  },
  computed: {
    spineImageSizeRecommended() {
      return this.lang.spine_note_image_size
        .replace(":width", this.spineImageWidthRecommended)
        .replace(":height", this.spineImageHeightRecommended);
    }
  },
  methods: {
    initialData() {
      this.spineCoverType = this.initialSpineCoverType;
      this.spineImageFile = null;
      this.spineImageDataUrl = null;
      this.errorMessages = [];
    },
    onClickEditButton() {
      this.selectSpineImageDialog = true;
    },
    onClickSpineImageFile() {
      this.$refs.spineImageFileInput.click();
    },
    onChangeSpineImageFileInput(e) {
      const files = e.target.files;
      this.errorMessages = [];

      if (files[0] == undefined) {
        return;
      }

      const file = files[0];

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        const message = this.lang.spine_edit_error_file_type.replace(
          ":filename",
          file.name
        );
        this.errorMessages.push(message);
        return;
      }

      if (file.size > MAX_IMAGE_FILE_SIZE) {
        const message = this.lang.spine_edit_error_image_size
          .replace(":filename", file.name)
          .replace(":max_size", MAX_IMAGE_FILE_SIZE_HUMAN);
        this.errorMessages.push(message);
        return;
      }

      this.setIsBusy(true);

      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.onload = () => {
        this.spineImageFile = file;
        this.spineImageDataUrl = fr.result;

        this.setIsBusy(false);
      };
    },
    async onClickSaveButton() {
      switch (this.spineCoverType) {
        case "simple":
          this.updateSpineCoverType(this.spineCoverType);
          this.selectSpineImageDialog = false;
          break;

        case "user_upload":
          if (!this.userSpineImageUrl && !this.spineImageFile) {
            this.errorMessages = [];
            this.errorMessages.push(this.lang.spine_edit_error_require_file);
            break;
          }

          this.updateSpineCoverType(this.spineCoverType);

          if (this.spineImageFile) {
            await this.postUserSpineImage(this.spineImageFile);
          }

          this.selectSpineImageDialog = false;
          break;
      }
    }
  }
};
</script>

<style module lang="scss">
.btnTextStyle {
  text-transform: none !important;
}

.noteList {
  list-style: none;
  padding-left: 0;
  li:before {
    content: "*";
  }
}

.headingText {
  font-weight: bold;
  font-size: 16px;
}

.radioContainer {
  width: 100%;

  &__container {
    flex-basis: 50% !important;
    padding: 0 8px;

    &__xs {
      flex-basis: auto !important;
      padding: 8px 0;
    }
  }

  &__borderBox {
    border: solid;
    border-color: gray;
    border-radius: 10px;
    padding: 24px;
    text-align: center;
    cursor: pointer;
  }

  &__radioContainer {
    position: relative;
    margin-top: 40px;
    height: calc(100% - 40px);
    &__xs {
      margin-top: 0;
      margin-left: 40px;
      height: 100%;
    }
  }

  &__radio {
    position: absolute;
    left: 50%;
    top: -40px;
    transform: translateX(-50%);

    &__xs {
      left: -40px;
      top: 50%;
      transform: translateY(-50%);
    }

    * {
      margin: 0 !important;
    }
  }
}
</style>
